import { Routes, Route } from "react-router-dom";
import "./App.css";
import Registration from "./pages/Registration";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import Invite from "./pages/Invite";
import { Provider } from "react-redux";
import { store } from "./store";
import SuccessInvitationProcess from "./pages/SuccessInvitationProcess";
import SuccessRegistrationProcess from "./pages/SuccessRegistrationProcess";
import OwnerProfile from "./pages/OwnerProfile";
import EmployeeAuthenticatedRoute from "./components/EmployeeAuthenticatedRoute";

type AppProps = {
  instance: PublicClientApplication;
};
function App({ instance }: AppProps) {
  return (
    <Provider store={store}>
      <MsalProvider instance={instance}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />}></Route>
            <Route path="registration" element={<Registration />}></Route>
            <Route path="invite" element={<Invite />}></Route>
            <Route
              path="success-invitation"
              element={<SuccessInvitationProcess />}
            ></Route>
            <Route
              path="success-registration"
              element={<SuccessRegistrationProcess />}
            ></Route>
            <Route
              path="owner-profile"
              element={
                <EmployeeAuthenticatedRoute>
                  <OwnerProfile />
                </EmployeeAuthenticatedRoute>
              }
            ></Route>
          </Route>
        </Routes>
      </MsalProvider>
    </Provider>
  );
}

export default App;

